module.exports = __webpack_public_path__ + "static/media/module6-male.72b49b1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/module6-male.mp4
// module id = M18M
// module chunks = 0